// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__utuYm","total":"AdvancePaymentDetails_total__cCs2P","edit":"AdvancePaymentDetails_edit__U3mZf"};